import React from "react";
import Sidebar from "../../components/Sidebar";
import ConsumerMerchantPositionTable from "./components/ConsumerMerchantPositionTable";

const ConsumerMerchantPositionPage = () => {
  return (
    <div className="flex overflow-hidden flex-col h-screen md:flex-row">
      <Sidebar />
      <div className="overflow-y-auto flex-1 p-4 bg-white md:py-7">
        <h1 className="py-4 mb-0 text-xl font-bold md:text-2xl md:mb-6">Treasury: Consumer ↔ Merchant Position</h1>
        <div className=""><ConsumerMerchantPositionTable /></div>
      </div>
    </div>
  );
};

export default ConsumerMerchantPositionPage;
